export default __webpack_public_path__ + "static/media/Tallyfy.7515d9f9.png";